import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-629c590a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "grid"
}
const _hoisted_2 = { class: "center" }

import ShapeDrillHoleGeneratorFactory from '../Models/ShapeDrillHoleGeneratorFactory';

import {computed, onBeforeUnmount, onMounted} from "vue";
import { useStore } from "vuex";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import { stripNonNumeric } from '@/functions/numbers';
import { StepTypes } from '@/types/step';


export default /*#__PURE__*/_defineComponent({
  __name: 'DrillHoleEdgeCounts',
  setup(__props) {

const store = useStore();

const shape = computed(() => store.getters.shape );
const model = computed(() => store.getters.model );
const lastGeneratedConfiguration = computed(() => store.getters.lastGeneratedConfiguration );
const drillHoleEdgeHoles = computed(() => store.getters.drillHoleEdgeHoles );
const drillHoleOffset = computed( () => store.getters.drillHoleOffset );
const isMediaMobileSize = computed( () => store.getters.isMediaMobileSize );
const currentStepName = computed( () => store.getters.currentStepName );

function countEdges() {
	const shapeDrillHoleGenerator = (new ShapeDrillHoleGeneratorFactory()).getShapeDrillHoleGenerator( shape.value, model.value );

	if ( ( 'getPath' in shapeDrillHoleGenerator ) ) {
		return shapeDrillHoleGenerator.getPath( drillHoleOffset.value ).length;
	}

	return 0;
}

const edges = computed(() => {
	const edges = [];
	const sides = countEdges();

	const classes = sides === 4 ? [ 'top', 'right', 'bottom', 'left' ] : [ 'right', 'bottom', 'left' ];

	for( let i = 0; i < sides; i++ ) {
		edges.push( { side: classes[ i ], holes: Math.round( drillHoleEdgeHoles.value[ i ] ?? 1 ) } );
	}

	return edges;
});

document.addEventListener("focusin", focusChanged);

function focusChanged(event) {
	store.commit("updateFocusedElement", event.target);
}

onMounted(async () => {

	// Don't set defaults if we have an old configuration available for edge drill holes.
	if ( lastGeneratedConfiguration.value.drillholes?.type === 'edges' && lastGeneratedConfiguration.value.drillholes?.edgeType === 'around' ) {
		return;
	}

	const defaultHoles = new Array( countEdges() );

	defaultHoles.fill( 1 );

	store.commit('updateEdgeHoles', defaultHoles );
});

onBeforeUnmount(() => {
	store.commit( 'updateEdgeHoles', [] );

	document.removeEventListener("focusin", focusChanged);
});

function updateDrillEdgeHoles(value, index) {
	const data = [...drillHoleEdgeHoles.value]; // Make a shallow copy to prevent modifying the original object. This woudl break reactivity.
	data[index] = stripNonNumeric(value);

	store.commit( 'updateEdgeHoles', data);
}

return (_ctx: any,_cache: any) => {
  const _component_portal_target = _resolveComponent("portal-target")!

  return (isMediaMobileSize.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(edges.value, (holeInfo, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass({ [holeInfo.side]: true })
          }, [
            _createVNode(DimensionInput, {
              inputRef: `drillHoleEdgeCount_${index}`,
              id: `drillHoleEdgeCount_${index}`,
              name: `drillHoleEdgeCount_${index}`,
              inputmode: "numeric",
              type: "text",
              step: 1,
              min: 0,
              modelValue: holeInfo.holes,
              "onUpdate:modelValue": ($event: any) => (updateDrillEdgeHoles($event, index)),
              invalid: false
            }, null, 8, ["inputRef", "id", "name", "modelValue", "onUpdate:modelValue"])
          ], 2))
        }), 128)),
        _createElementVNode("div", _hoisted_2, [
          (isMediaMobileSize.value && currentStepName.value === _unref(StepTypes).drillholes)
            ? (_openBlock(), _createBlock(_component_portal_target, {
                key: 0,
                name: "mobile-accordion-preview"
              }))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(edges.value, (holeInfo, index) => {
        return (_openBlock(), _createBlock(DimensionInput, {
          key: index,
          inputRef: `drillHoleEdgeCount_${index}`,
          id: `drillHoleEdgeCount_${index}`,
          name: `drillHoleEdgeCount_${index}`,
          inputmode: "numeric",
          step: 1,
          min: 0,
          label: `${_ctx.$i18n.drillHoleConfiguration.edge} ${index +1}`,
          modelValue: holeInfo.holes,
          "onUpdate:modelValue": ($event: any) => (updateDrillEdgeHoles($event, index)),
          invalid: false
        }, null, 8, ["inputRef", "id", "name", "label", "modelValue", "onUpdate:modelValue"]))
      }), 128))
}
}

})